import './root.css';
import {Link, useMatches} from "react-router-dom";

export default function Breadcrumb() {
    const matches = useMatches();
    const crumbs = matches.filter(match => match.handle?.breadcrumb)
        .map(match => match.handle.breadcrumb(match));

    return crumbs.length > 0 && (
        <div className="breadcrumb">
            {crumbs.map((crumb, index) => {
                    return (
                        <>
                            <div key={index}>
                                <Link to={crumb.pathname}>
                                    {crumb.label}
                                </Link>
                            </div>
                            {index < crumbs.length - 1 && <span className="separator"> > </span>}
                        </>
                    )
                }
            )}
        </div>
    );
}
